document.addEventListener('DOMContentLoaded', () => {
  function cleanVariantUrl() {
    try {
      if (window.location.search && window.location.search.includes('variant=')) {
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.delete('variant');
        const cleanUrl = currentUrl.pathname + (currentUrl.search ? currentUrl.search : '') + currentUrl.hash;
        window.history.replaceState({}, '', cleanUrl);
      }
    } catch (e) {}
  }

  // Strip ?variant parameter if present in the URL on load
  cleanVariantUrl();

  // --- Thumbnail to Main Media (Image / Video) ---
  const mainImg = document.getElementById('cpd-main-img');
  const mainVideo = document.getElementById('cpd-main-video');
  const thumbnails = document.querySelectorAll('.cpd__thumbnail');
  const thumbContainer = document.getElementById('cpd-thumbnails');
  let imageRequestId = 0;
  let updateThumbArrowState = () => {};

  function setActiveThumbnail(thumb, shouldScroll = true) {
    if (!thumb) return;

    thumbnails.forEach(item => {
      const isActive = item === thumb;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-current', isActive ? 'true' : 'false');
    });

    if (shouldScroll) {
      thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    }
  }

  function changeMainMedia(thumb, shouldScroll = true) {
    if (!thumb) return;

    setActiveThumbnail(thumb, shouldScroll);

    if (thumb.dataset.isVideo === 'true') {
      if (mainImg) mainImg.style.display = 'none';
      if (mainVideo) {
        mainVideo.style.display = 'block';
        if (thumb.dataset.videoUrl) {
          const srcEl = mainVideo.querySelector('source');
          if (srcEl && srcEl.src !== thumb.dataset.videoUrl) {
            srcEl.src = thumb.dataset.videoUrl;
            mainVideo.load();
          } else if (!srcEl) {
            mainVideo.src = thumb.dataset.videoUrl;
          }
        }
        mainVideo.play().catch(() => {});
      }
      return;
    }

    if (mainVideo) {
      try { mainVideo.pause(); } catch(e) {}
      mainVideo.style.display = 'none';
    }

    if (mainImg) {
      mainImg.style.display = 'block';
      if (!thumb.dataset.src || mainImg.src === thumb.dataset.src) return;

      const requestId = ++imageRequestId;
      const nextImage = new Image();
      mainImg.classList.add('is-changing');
      nextImage.onload = () => {
        if (requestId !== imageRequestId) return;
        mainImg.src = thumb.dataset.src;
        mainImg.alt = thumb.querySelector('img')?.alt || mainImg.alt;
        requestAnimationFrame(() => mainImg.classList.remove('is-changing'));
      };
      nextImage.onerror = () => {
        if (requestId === imageRequestId) mainImg.classList.remove('is-changing');
      };
      nextImage.src = thumb.dataset.src;
    }
  }

  function changeMainImage(thumb, shouldScroll = true) {
    changeMainMedia(thumb, shouldScroll);
  }
  
  if (thumbnails.length > 0) {
    thumbnails.forEach(thumb => {
      thumb.addEventListener('click', () => {
        changeMainMedia(thumb);
      });
    });
  }

  // --- Thumbnail Scroll Arrows ---
  const thumbPrev = document.getElementById('cpd-thumb-prev');
  const thumbNext = document.getElementById('cpd-thumb-next');

  if (thumbPrev && thumbNext && thumbContainer) {
    const getThumbnailStep = () => {
      const visibleThumb = Array.from(thumbnails).find(thumb => !thumb.hidden && !thumb.classList.contains('is-filtered-out'));
      if (!visibleThumb) return 0;
      const gap = parseFloat(getComputedStyle(thumbContainer).columnGap) || 0;
      return visibleThumb.getBoundingClientRect().width + gap;
    };

    updateThumbArrowState = () => {
      const maxScroll = Math.max(0, thumbContainer.scrollWidth - thumbContainer.clientWidth);
      const hasOverflow = maxScroll > 1;

      thumbPrev.hidden = !hasOverflow;
      thumbNext.hidden = !hasOverflow;
      thumbPrev.disabled = !hasOverflow || thumbContainer.scrollLeft <= 1;
      thumbNext.disabled = !hasOverflow || thumbContainer.scrollLeft >= maxScroll - 1;
    };

    thumbPrev.addEventListener('click', () => {
      thumbContainer.scrollBy({ left: -getThumbnailStep(), behavior: 'smooth' });
    });
    thumbNext.addEventListener('click', () => {
      thumbContainer.scrollBy({ left: getThumbnailStep(), behavior: 'smooth' });
    });
    thumbContainer.addEventListener('scroll', updateThumbArrowState, { passive: true });
    window.addEventListener('resize', updateThumbArrowState);
    requestAnimationFrame(updateThumbArrowState);
  }

  // --- Smooth Accordion Toggle ---
  const accordionHeaders = document.querySelectorAll('.cpd__accordion-header');
  accordionHeaders.forEach(header => {
    header.addEventListener('click', () => {
      const accordion = header.closest('.cpd__accordion');
      const content = accordion.querySelector('.cpd__accordion-content');
      const icon = header.querySelector('.cpd__accordion-icon') || header.querySelector('span:last-child');
      
      if (accordion.classList.contains('is-open')) {
        accordion.classList.remove('is-open');
        if (content) {
          content.style.maxHeight = '0px';
          content.style.opacity = '0';
        }
        if (icon) icon.textContent = '+';
      } else {
        accordion.classList.add('is-open');
        if (content) {
          content.style.maxHeight = content.scrollHeight + 40 + 'px';
          content.style.opacity = '1';
        }
        if (icon) icon.textContent = '-';
      }
    });
  });

  // --- Slide-out Right Sidebar Drawers ---
  const drawerTriggers = document.querySelectorAll('[data-drawer-trigger]');
  const drawerOverlay = document.getElementById('cpd-drawer-overlay');

  function closeAllDrawers() {
    document.querySelectorAll('.cpd-drawer.is-active').forEach(d => d.classList.remove('is-active'));
    if (drawerOverlay) drawerOverlay.classList.remove('is-active');
    document.body.style.overflow = '';
  }

  drawerTriggers.forEach(trigger => {
    trigger.addEventListener('click', () => {
      const targetId = trigger.getAttribute('data-drawer-trigger');
      const targetDrawer = document.getElementById(targetId);
      if (targetDrawer && drawerOverlay) {
        closeAllDrawers();
        targetDrawer.classList.add('is-active');
        drawerOverlay.classList.add('is-active');
        document.body.style.overflow = 'hidden';
      }
    });
  });

  document.querySelectorAll('[data-close-drawer]').forEach(btn => {
    btn.addEventListener('click', closeAllDrawers);
  });
  if (drawerOverlay) drawerOverlay.addEventListener('click', closeAllDrawers);

  // --- Quantity Selector ---
  const qtyInput = document.getElementById('cpd-qty');
  const qtyMinus = document.getElementById('cpd-qty-minus');
  const qtyPlus = document.getElementById('cpd-qty-plus');
  
  const qtyDisplay = document.getElementById('cpd-qty-display');
  
  if (qtyInput && qtyMinus && qtyPlus) {
    qtyMinus.addEventListener('click', () => {
      let val = parseInt(qtyInput.value) || 1;
      if (val > 1) {
        let newVal = (val - 1).toString();
        qtyInput.value = newVal;
        if (qtyDisplay) qtyDisplay.textContent = newVal;
      }
    });
    qtyPlus.addEventListener('click', () => {
      let val = parseInt(qtyInput.value) || 1;
      let newVal = (val + 1).toString();
      qtyInput.value = newVal;
      if (qtyDisplay) qtyDisplay.textContent = newVal;
    });
  }

  // --- Variant Selection Logic ---
  // In Shopify, variants are combinations of options (e.g. Option1: Type, Option2: Color)
  // We will listen to all custom radio inputs and find the matching variant.
  
  const variantRadios = document.querySelectorAll('.cpd__variant-radio');
  const variantDataScript = document.getElementById('cpd-variant-data');
  const variantInput = document.getElementById('cpd-variant-id');
  const priceEl = document.getElementById('cpd-price');
  const comparePriceEl = document.getElementById('cpd-compare-price');
  const badgeEl = document.getElementById('cpd-badge');
  const addBtn = document.getElementById('cpd-add-btn');
  
  let variants = [];
  try {
    if (variantDataScript) {
      const rawJson = (variantDataScript.textContent || '').replace(/\u00a0/g, ' ').trim();
      variants = JSON.parse(rawJson);
    }
  } catch (e) {
    console.error('Error parsing variant data', e);
  }

  // --- Show only thumbnails whose alt text matches the selected variant options ---
  function normalizeAltValue(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/grey/g, 'gray')
      .replace(/\+/g, ' ')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function optionValueFoundInAlt(altText, optionValues) {
    const normalizedAlt = ` ${normalizeAltValue(altText)} `;
    const valuesBySpecificity = optionValues
      .map(normalizeAltValue)
      .filter(Boolean)
      .sort((a, b) => b.length - a.length);

    return valuesBySpecificity.find(value => normalizedAlt.includes(` ${value} `)) || '';
  }

  function setThumbnailVisibility(thumb, shouldShow) {
    if (thumb.dataset.isVideo === 'true') {
      thumb.hidden = false;
      thumb.classList.remove('is-filtered-out');
      return;
    }

    if (shouldShow) {
      thumb.hidden = false;
      thumb.classList.remove('is-filtered-out');
      return;
    }

    // Hide non-matching variant media immediately so stale thumbnails never flash.
    thumb.hidden = true;
    thumb.classList.remove('is-filtered-out');
    thumb.classList.remove('is-active');
    thumb.setAttribute('aria-current', 'false');
  }

  function filterThumbnailsBySelectedOptions(optionGroups) {
    if (!thumbnails.length) return;

    // Only enforce an option group when its values are actually present in image alt text.
    // This supports stores that tag images by Sofa Type only, or by Sofa Type + Color.
    const altFilters = optionGroups.filter(group => Array.from(thumbnails).some(thumb => (
      optionValueFoundInAlt(thumb.dataset.alt, group.values)
    )));

    const matchingThumbs = Array.from(thumbnails).filter(thumb => altFilters.every(group => {
      const valueInAlt = optionValueFoundInAlt(thumb.dataset.alt, group.values);
      return valueInAlt === normalizeAltValue(group.selected);
    }));

    // If no alt values have been configured, keep the gallery usable instead of hiding everything.
    const visibleThumbs = altFilters.length && matchingThumbs.length
      ? matchingThumbs
      : Array.from(thumbnails);

    thumbnails.forEach(thumb => setThumbnailVisibility(thumb, visibleThumbs.includes(thumb)));

    // Ensure the video thumbnail is always placed as the 2nd visible thumbnail for every variant and size
    const videoThumb = thumbContainer ? thumbContainer.querySelector('.cpd__thumbnail--video') : null;
    if (videoThumb) {
      const firstVisibleImg = Array.from(thumbContainer.querySelectorAll('.cpd__thumbnail:not(.cpd__thumbnail--video)')).find(t => !t.hidden);
      if (firstVisibleImg) {
        firstVisibleImg.after(videoThumb);
      } else {
        thumbContainer.prepend(videoThumb);
      }
      videoThumb.hidden = false;
    }

    const activeThumb = document.querySelector('.cpd__thumbnail.is-active');
    if (!activeThumb || !visibleThumbs.includes(activeThumb) || activeThumb.dataset.isVideo === 'true') {
      const firstImgThumb = visibleThumbs.find(t => t.dataset.isVideo !== 'true') || visibleThumbs[0];
      changeMainMedia(firstImgThumb);
    } else {
      setActiveThumbnail(activeThumb);
    }

    if (thumbContainer) thumbContainer.scrollTo({ left: 0, behavior: 'smooth' });
    requestAnimationFrame(updateThumbArrowState);
  }

  function updateVariant(updateUrl = true) {
    // Get currently selected options
    const selectedOptions = [];
    const selectedMediaOptions = [];

    document.querySelectorAll('.cpd__variant-group').forEach((group) => {
      const checked = group.querySelector('.cpd__variant-radio:checked');
      if (checked) {
        selectedOptions.push(checked.value);
        
        // Update label value display if exists
        const valDisplay = group.querySelector('.cpd__variant-label span');
        if (valDisplay) {
          valDisplay.textContent = checked.value;
        }

        selectedMediaOptions.push({
          selected: checked.value,
          values: Array.from(group.querySelectorAll('.cpd__variant-radio')).map(radio => radio.value)
        });
      }
    });

    filterThumbnailsBySelectedOptions(selectedMediaOptions);

    // Find matching variant
    let matchedVariant = null;
    if (variants.length === 1 && selectedOptions.length === 0) {
      matchedVariant = variants[0];
    } else {
      matchedVariant = variants.find(v => {
        return (
          v.options.length === selectedOptions.length &&
          v.options.every((opt, idx) => String(opt).trim().toLowerCase() === String(selectedOptions[idx]).trim().toLowerCase())
        );
      });
    }

    if (matchedVariant) {
      // Update form ID
      if (variantInput) {
        variantInput.value = matchedVariant.id;
      }

      // Keep URL clean without ?variant
      cleanVariantUrl();
      
      // Update Price
      if (priceEl) priceEl.textContent = matchedVariant.price;
      
      if (comparePriceEl) {
        if (matchedVariant.compare_at_price) {
          comparePriceEl.textContent = matchedVariant.compare_at_price;
          comparePriceEl.style.display = 'inline';
        } else {
          comparePriceEl.style.display = 'none';
        }
      }

      // Update Badge
      if (badgeEl) {
        if (matchedVariant.discount_percentage) {
          badgeEl.textContent = '-' + matchedVariant.discount_percentage + '%';
          badgeEl.style.display = 'inline-block';
        } else {
          badgeEl.style.display = 'none';
        }
      }
      
      // Update Add to Cart Button
      if (addBtn) {
        if (matchedVariant.available || matchedVariant.inventory_quantity > 0) {
          addBtn.disabled = false;
          addBtn.textContent = 'Add To Cart';
        } else {
          addBtn.disabled = true;
          addBtn.textContent = 'Sold Out';
        }
      }

      // Update Image if variant has specific image
      if (matchedVariant.featured_image && mainImg) {
        const cleanVarImg = matchedVariant.featured_image.split('?')[0].split('#')[0];
        const activeThumb = Array.from(thumbnails).find(t => {
          if (t.dataset.isVideo === 'true' || !t.dataset.src) return false;
          const cleanThumbSrc = t.dataset.src.split('?')[0].split('#')[0];
          const varFileName = cleanVarImg.split('/').pop();
          const thumbFileName = cleanThumbSrc.split('/').pop();
          return (
            cleanThumbSrc === cleanVarImg ||
            (Boolean(varFileName) && cleanThumbSrc.includes(varFileName)) ||
            (Boolean(thumbFileName) && cleanVarImg.includes(thumbFileName))
          );
        });
        if (activeThumb && !activeThumb.hidden && !activeThumb.classList.contains('is-filtered-out')) {
          changeMainImage(activeThumb);
        }
      }

    } else {
      // Unavailable combination
      if (addBtn) {
        addBtn.disabled = true;
        addBtn.textContent = 'Unavailable';
      }
    }
  }

  variantRadios.forEach(radio => {
    radio.addEventListener('change', () => {
      updateVariant();
      cleanVariantUrl();
    });
  });

  // Initial filter run on page load (clean URL)
  updateVariant();
  cleanVariantUrl();
});
